/**
 * スタイル定義
 */
export const styles = () => {
  return {
    manualUl: {
      margin: '0 0 8px 0',
      paddingLeft: '24px',
    },
  };
};
